export function inputAutofill() {
  $("#post-code").keyup(function () {
    AjaxZip3.zip2addr(this, "", "address01", "address01");
  });
}
